export default __webpack_public_path__ + "media/images/mailer/wordmark-edd946726c701f38697e5ff570bafb78.png";